// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__SttKi","inner":"Footer_inner__3jESZ","nextIcon":"Footer_nextIcon__-nrOi","innerLeft":"Footer_innerLeft__1Mx9F"};